import React from 'react';
import PropTypes from 'prop-types';
import { CheckOutlined } from '@ant-design/icons';
import styles from './styles.less';

const Hint = ({ text, classname }) => (
  <div className={styles[classname]}>
    <CheckOutlined className={styles.icon} />
    <p className={styles.hintSize}>{text}</p>
  </div>
);

Hint.propTypes = {
  text: PropTypes.string.isRequired,
  classname: PropTypes.string.isRequired,
};

export default Hint;
